import { QuestType, QUEST_PROGRESS_STATUS, QUEST_BACKGROUND_FLAG, QUEST_DATE_STATUS, REWARD_TYPE, TournamentEvent } from '@types';

/**
 * Transform tournament data to QuestType format for reuse in Quest component
 */
export const mapTournamentToQuest = (event: TournamentEvent, eventIndex: number): QuestType => {
	return {
		id: `tournament-quest-${eventIndex}`,
		categories: [],
		current_user_quest: {
			status: QUEST_PROGRESS_STATUS.NO_PROGRESS,
			progress: 0
		},
		description: [event.descriptionOne, event.descriptionTwo].filter(Boolean).join('<br><br>'),
		short_description: event.descriptionOne || '',
		name: event.nameQuest || '',
		date_end: event.endDate?.toISOString() || '',
		date_start: event.startDate?.toISOString() || '',
		image: event.imgQuest || '',
		is_image_cover: false,
		backgroundColor: QUEST_BACKGROUND_FLAG.PURPLE,
		modal_header_image_url: event.imgQuest || '',
		rewards: [
			{
				position: 1,
				id: `tournament-reward-${eventIndex}`,
				name: event.tegQuest || 'Турнирная награда',
				description: event.tegQuest || 'Награда за участие в турнире',
				reward_type: REWARD_TYPE.OTHER,
				amount: '1',
				currency: '',
				image_url: ''
			}
		],
		timer: false,
		endless: false,
		url: event.buttonUrl || null,
		frontend_state: QUEST_DATE_STATUS.STARTED,
		is_mirror_link: false
	};
}; 